(() => {
  function getTabIndexForKey(key, currentIndex, tabCount) {
    if (tabCount < 2) return currentIndex;

    switch (key) {
      case 'ArrowRight':
        return (currentIndex + 1) % tabCount;
      case 'ArrowLeft':
        return (currentIndex - 1 + tabCount) % tabCount;
      case 'Home':
        return 0;
      case 'End':
        return tabCount - 1;
      default:
        return currentIndex;
    }
  }

  function getTabElements(sectionElement) {
    return {
      tabs: Array.from(sectionElement.querySelectorAll('[data-kl-bestsellers-tab]')),
      panels: Array.from(sectionElement.querySelectorAll('[data-kl-bestsellers-panel]')),
    };
  }

  function activatePanel(panel) {
    const template = panel.querySelector(':scope > template[data-kl-bestsellers-template]');

    if (!template) return;

    const fragment = template.content.cloneNode(true);

    template.replaceWith(fragment);

    try {
      document.dispatchEvent(new CustomEvent('kl:content:added', { detail: { root: panel } }));
    } catch (error) {
      console.debug('kl-bestsellers: could not announce the added panel content', { error });
    }
  }

  function updateSelection(tabs, panels, selectedIndex, canMoveFocus) {
    const selectedTab = tabs[selectedIndex];

    if (!selectedTab) return;

    try {
      const selectedBlockId = selectedTab.dataset.klBestsellersTab;

      tabs.forEach((tab, index) => {
        const isSelected = index === selectedIndex;

        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isSelected = panel.dataset.klBestsellersPanel === selectedBlockId;

        if (isSelected) activatePanel(panel);

        panel.hidden = !isSelected;
      });

      if (canMoveFocus) selectedTab.focus();
    } catch (error) {
      console.debug('kl-bestsellers: could not switch collection', { selectedIndex, error });
    }
  }

  function selectBlock(sectionElement, blockId) {
    const { tabs, panels } = getTabElements(sectionElement);
    const selectedIndex = tabs.findIndex((tab) => tab.dataset.klBestsellersTab === blockId);

    if (selectedIndex < 0) return;

    updateSelection(tabs, panels, selectedIndex, false);
  }

  function initBestsellers(sectionElement) {
    const { tabs, panels } = getTabElements(sectionElement);

    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => updateSelection(tabs, panels, index, false));

      tab.addEventListener('keydown', (event) => {
        const nextIndex = getTabIndexForKey(event.key, index, tabs.length);

        if (nextIndex === index) return;

        event.preventDefault();
        updateSelection(tabs, panels, nextIndex, true);
      });
    });

    const renderedIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');

    updateSelection(tabs, panels, Math.max(0, renderedIndex), false);
  }

  document.querySelectorAll('[data-kl-bestsellers]').forEach(initBestsellers);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-kl-bestsellers]').forEach(initBestsellers);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('[data-kl-bestsellers-panel]');

    if (!panel) return;

    const sectionElement = panel.closest('[data-kl-bestsellers]');

    if (!sectionElement) return;

    selectBlock(sectionElement, panel.dataset.klBestsellersPanel);
  });
})();
